<template>
  <div class="magic-ball">
    <ul class="reward-list">
      <li
        :class="`reward-item-${index+1}`"
        :key="index"
        class="reward-item"
        v-for="(item, index) in reward"
      >
        <c-tooltip :content="item.item_name">
          <item @click.native="handleClick(item)" v-bind="formatData(item)" />
        </c-tooltip>
        <div class="reward-cost">
          <span class="real-cost gem">{{item.realCost}}</span>
          <span class="current-cost">{{item.cost}}</span>
        </div>
      </li>
    </ul>
    <button
      :class="{unrefresh:!refreshable||drawing||refreshing}"
      @click="$bus.purchase(chosen)"
      class="buy-btn"
    >
      <span class="buy-btn-text">{{buyBtnTxt}}</span>
    </button>
    <div class="buy-hint" v-html="chooseTxt"></div>
  </div>
</template>
<script>
  import { mapState } from '@/utils/assist'
  import Item from '@/components/item/item'
  export default {
    name: 'MagicBall',
    components: {
      Item,
    },
    computed: {
      ...mapState(['transify', 'refreshable', 'reward', 'drawing', 'refreshing']),
      chooseTxt() {
        const chosen = this.reward.filter(item => item.checked)
        const total = chosen.reduce((acc, cur) => acc + cur.realCost, 0)
        return this.transify['CHANGE_CHOOSE_PRICE']
          .replace('{num/num}', `<span class="buy-yellow">${chosen.length}/3</span>`)
          .replace('{gem num}', `<span class="gem buy-yellow">${total}</span>`)
      },
      buyBtnTxt() {
        return this.refreshable ? this.transify['CHANGE_BUY_NOW'] : this.transify['CHANGE_DONE']
      },
      chosen() {
        return this.reward.filter(item => item.checked)
      },
    },
    methods: {
      // 格式化 item
      formatData(item) {
        return {
          image: item.item_img,
          num: item.item_num,
          purchased: item.purchased,
          checked: item.checked,
          rarity: item.rarity,
          showCheck: this.refreshable,
        }
      },
      handleClick(item) {
        this.$bus.addGA('rewardItem', 'click')
        if (!this.refreshable) return
        if (item.purchased) return
        if (item.checked) {
          item.checked = false
        } else {
          const count = this.reward.reduce((acc, cur) => acc + (cur.checked ? 1 : 0), 0)
          if (count >= 3) return
          item.checked = true
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  .magic-ball {
    position: absolute;
    @include px2res(bottom, 18);
    left: 0;
    width: 100vw;
    text-align: center;
    z-index: 15;
    .reward-list {
      position: relative;
      margin: 0 auto;
      @include px2res(width, 410);
      @include px2res(height, 425);
      .reward-item {
        position: absolute;
        &-1 {
          top: 0;
          left: 0;
        }
        &-2 {
          @include px2res(left, 150);
          top: 0;
        }
        &-3 {
          right: 0;
          top: 0;
        }
        &-4 {
          left: 0;
          @include px2res(top, 144);
        }
        &-5 {
          @include px2res(left, 150);
          @include px2res(top, 144);
        }
        &-6 {
          right: 0;
          @include px2res(top, 144);
        }
        &-7 {
          left: 0;
          @include px2res(top, 288);
        }
        &-8 {
          @include px2res(left, 150);
          @include px2res(top, 288);
        }
        &-9 {
          right: 0;
          @include px2res(top, 288);
        }
      }
      .reward-cost {
        @include px2res(margin-top, 2);
        letter-spacing: 1px;
        background: linear-gradient(
          to right,
          rgba(0, 0, 0, 0),
          rgba(3, 10, 76, 0.7) 20%,
          rgba(3, 10, 76, 0.7) 70%,
          rgba(0, 0, 0, 0)
        );
      }
    }
    .buy-btn {
      display: block;
      margin: 0 auto;
      @include px2res(margin-top, 5);
      @include px2res(width, 431);
      @include px2res(height, 96);
      &.unrefresh .buy-btn-text {
        filter: grayscale(1);
      }
      .buy-btn-text {
        @include px2res(line-height, 100);
        // @include text-gradient(#001448 50%, #045d94 80%);
        color: #fff;
        @include px2res(font-size, 48);
      }
    }
    .buy-hint {
      display: inline-block;
      @include px2res(padding, 7, 0, 3);
      @include px2res(font-size, 30);
      font-family: $teko-font-family;
      white-space: nowrap;
      background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0),
        rgba(21, 21, 21, 1) 20%,
        rgba(21, 21, 21, 1) 80%,
        rgba(0, 0, 0, 0)
      );
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/magic-ball/magic-ball.vue